module.exports = __webpack_public_path__ + "img/settings-blue.2fe5dd9b.svg";